/* Mu account Wmh79J. Notification list SUaGN5 has no sending flow. */
if (!customElements.get('mu-stock-notify')) {
  customElements.define('mu-stock-notify', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.form = this.querySelector('form');
      this.form.addEventListener('submit', (event) => this.submit(event));
      this.onVariant = (event) => {
        if (!event.target.closest('[id]') || !this.closest('[data-section-id],.shopify-section')?.contains(event.target)) return;
        const variant = event.detail?.variant;
        if (!variant) return;
        this.dataset.variantId = variant.id;
        this.hidden = variant.available;
      };
      document.addEventListener('theme:variant:change', this.onVariant);
    }
    disconnectedCallback() { document.removeEventListener('theme:variant:change', this.onVariant); }
    async request(path, payload) {
      const controller = new AbortController();
      const timeout = setTimeout(() => controller.abort(), 15000);
      try {
        const response = await fetch(`https://a.klaviyo.com/client/${path}/?company_id=Wmh79J`, {
          method: 'POST', headers: { 'Content-Type': 'application/vnd.api+json', revision: '2026-07-15' },
          body: JSON.stringify(payload), signal: controller.signal
        });
        if (!response.ok) throw new Error(`Notification request failed (${response.status})`);
      } finally { clearTimeout(timeout); }
    }
    async submit(event) {
      event.preventDefault();
      if (this.pending || !this.form.reportValidity()) return;
      this.pending = true;
      const button = this.form.querySelector('button');
      const status = this.form.querySelector('[role="status"]');
      button.disabled = true;
      button.textContent = 'Saving…';
      status.textContent = '';
      const email = this.form.elements.email.value.trim();
      const variantId = this.dataset.variantId;
      try {
        // Queue by variant so separate product requests remain distinct.
        await this.request('back-in-stock-subscriptions', { data: {
          type: 'back-in-stock-subscription', attributes: {
            profile: { data: { type: 'profile', attributes: { email } } }, channels: ['EMAIL']
          }, relationships: { variant: { data: { type: 'catalog-variant', id: `$shopify:::$default:::${variantId}` } } }
        } });
        await this.request('subscriptions', { data: {
          type: 'subscription', attributes: {
            custom_source: 'Mu product restock request',
            profile: { data: { type: 'profile', attributes: {
              email, properties: { mu_restock_product: this.dataset.productName,
                mu_restock_product_id: this.dataset.productId, mu_restock_variant_id: variantId,
                mu_restock_requested_at: new Date().toISOString(), mu_email_consent_purpose: 'Product restock notification' },
              subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } }
            } } }
          }, relationships: { list: { data: { type: 'list', id: 'SUaGN5' } } }
        } });
        status.textContent = "You're on the list. We'll email you when it's back.";
        button.textContent = 'Saved';
      } catch (error) {
        status.textContent = "We couldn't save your request. Please try again or email hello@muvitality.com.";
        button.disabled = false;
        button.textContent = 'Notify me';
      } finally { this.pending = false; }
    }
  });
}
